import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {
	Button,
	Col,
	Container,
	Row
} from 'reactstrap';

import logo from '../img/ecofresh-logo.png';

class AdminLogin extends Component {
	handleLoginButton = () => {
		window.location.href = '/api/auth/google';
	}
	
	render() {
		return (
			<div>
				{!this.props.isAuthenticated ? (
					<Container className='text-center'>
						<Row>
							<Col className='mt-5 mb-5'>
								<img src={logo} className='img-fluid' alt='logo' />
							</Col>
						</Row>
						<Row>
							<Col className='mt-5 mb-5'>
								<Button color='primary' onClick={() => this.handleLoginButton()}>Login with Google</Button>
							</Col>
						</Row>
					</Container>
				) : (
					<Redirect to='/admin/cp' />
				)}
			</div>
		);
	}
}

export default AdminLogin;


// WEBPACK FOOTER //
// ./src/admin-components/AdminLogin.js